module.exports = __webpack_public_path__ + "nunito-sans-latin-300italic.246f6e2b70f0b23e366947c975effa65.woff2";